import { insertWordBasedOnStrategy } from '../insertion/insertBasedOnStrategy';
import { getEnabledDirections, isAllDiagonalEnabled, resolveValidDirection } from './directionUtils';

export class NormalStrategy {
  constructor(engine) {
    this.engine = engine;
  }

  place(wordsList, game) {
    const enabledDirections = getEnabledDirections(this.engine.model.settings);
    const hasAllDiagonalDirections = isAllDiagonalEnabled(enabledDirections);
    const { rows, columns } = this.engine.model;

    wordsList.forEach((word, index) => {
      const initialDirection = enabledDirections[index % enabledDirections.length];

      const direction = resolveValidDirection(
        word,
        initialDirection,
        enabledDirections,
        rows,
        columns,
      );

      if (direction === null) {
        this.engine.state.addUnplaced(word);
        return;
      }

      insertWordBasedOnStrategy(
        this.engine,
        word,
        direction,
        hasAllDiagonalDirections,
        game,
      );
    });
  }
}
